import { Component, OnInit} from '@angular/core';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ModalInvoicePdfComponent} from '../../modal-invoice-pdf/modal-invoice-pdf.component';
import {ModalUploadComponent} from '../../modal-upload/modal-upload.component';
import * as decode from 'jwt-decode';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import * as XLSX from 'xlsx';

import {TranslateService} from 'ng2-translate/ng2-translate';

@Component({
  selector: 'app-close-orders',
  templateUrl: './close-orders.component.html',
  styleUrls: ['./close-orders.component.scss']
})
export class CloseOrdersComponent implements OnInit {
  selectable = true;
  removable = true;
  addOnBlur = true;
  selectableRef = true;
  removableRef = true;
  addOnBlurRef = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  userId: any;
  userToken: any


  temp = [];
  load = true;
  data: any = {};
  typeFileUpload: any;
  step = 0;
  loadBtn = false;
  checkedAll = false;
  arra = [];
  listReceptions = [];
  arrOc = [];
  arrRef = [];
  listSocieties = [];
  listPlanta = [];
  totalSelect = 0;
  total = 0;
  providersList = [];
  aplicaWorkFlow;
  tipoOrden = 1;
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  providerActive = false;
  providerDetail: any = {};
  perfilId;
  isExternal;
  showExtranjero = false;

  constructor(private toastr: ToastrService,
              public dialog: MatDialog,
              private gralService: GeneralService,
              private groupService: GroupService,
              private provService: ProvidersService,
              public  translate: TranslateService){
                translate.addLangs(['es', 'en']);
                translate.setDefaultLang('es');

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    console.log(tokenPayload)

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.userId = tokenPayload.Id;

    this.providerActive = (this.perfilId == '3' && this.isExternal) ? false : true;

    gralService.changeTextHead('SEARCHORDERSCLOSE');
    this.getSocieties();
    //this.getPlantas();
  }
  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }
  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }
  addProveedorSearch(option){
    console.log('option', option);
    let proveedor = option.split(' - ');
    this.data.provider = proveedor[0];
    this.myControl.setValue(proveedor[0]);
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      //console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(index) {

    const society = this.listSocieties[index];
    //const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
    if(society.NumProveedor){
      this.data.provider = society.NumProveedor;
    }

  }

  /*
  selectPlanta(index){
    const planta = this.listPlanta[index];
    if(planta.NoPlanta){
      this.data.plant = planta.NoPlanta;
    }
  }*/

  /*getPlantas(){
    this.provService.getPlantas(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listPlanta = data['Entidades'];

      }else{
        this.listPlanta = null;
      }
    }, (err) => {

      this.loadBtn = false;
      this.listPlanta = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }*/

  disabledProv() {
    return !this.providerActive;

    /*let resp = false;
    if(this.data.society){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
      if(society.NumProveedor){
        resp = true;
      }
    }
    return resp;*/
  }


  add(event: MatChipInputEvent): void {

    const input = event.input;
    const value = event.value;
    if(value.length > 0 ){
      if(value.length < 10 || value.length > 10  ){
        let msg10digs = "La orden de compra debe ser de 10 dígitos";
        if(this.translate.currentLang == "en"){
          msg10digs = "The purchase order must be 10 digits";
        }else if(this.translate.currentLang == "es"){
          msg10digs = "La orden de compra debe ser de 10 dígitos";
        }
        this.toastr.info(msg10digs, '');
        input.value = '';
        return ;
      }
      // Add our fruit
      if ((value || '').trim()) {
        this.arrOc.push(value.trim());
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
    }
  }
  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }
  addRef(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.arrRef.push(value.trim());
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }
  removeRef(oc): void {
    const index = this.arrRef.indexOf(oc);
    if (index >= 0) {
      this.arrRef.splice(index, 1);
    }
  }

  search(){
    // if(this.arrOc.length < 1 && !this.data.oc){
    //   this.toastr.error('Favor de ingresar un número de orden de compra', 'Error');
    //   return;
    // }
    if(!this.data.provider || !this.data.society){
      let msgRequired = "Favor de agregar los datos obligatorios";
        if(this.translate.currentLang == "en"){
          msgRequired = "Please add the required data";
        }else if(this.translate.currentLang == "es"){
          msgRequired = "Favor de agregar los datos obligatorios";
        }
      this.toastr.error(msgRequired, 'Error');
      return;
    }
    this.step = 0;
    this.listReceptions = null;
    this.temp = null;
    this.loadBtn = true;
    let params = '';
    if(this.arrOc.length > 0){
      for(let g = 0; g < this.arrOc.length; g++){
        params = params+this.arrOc[g]+',';
      }
      params = params.substring(0, params.length - 1);
    }else{
      params = this.data.oc;
    }
    let paramsRef = null;
    if (this.arrRef.length > 0) {
      paramsRef = '';
      for (let g = 0; g < this.arrRef.length; g++) {
        paramsRef = paramsRef + this.arrRef[g] + ',';
      }
      paramsRef = paramsRef.substring(0, paramsRef.length - 1);
    }
    //else {
      //paramsRef = this.data.ref;
    //}

    this.provService.getProviderNum(this.userToken, this.data.provider ).then((res:any)=>{
      this.providerDetail = res.Entidad;

      if( this.providerDetail){
        this.showExtranjero =  this.providerDetail.Proveedor.EsExtranjero ;
      }
    });

    this.provService.searchOC(params, this.data.society, paramsRef, this.data.provider, 1, this.userId, this.userToken)
    .then((data) => {
      this.loadBtn = false;
      if(data['PO_Receptions_Available'].length > 0){
        this.listReceptions = data['PO_Receptions_Available'];
        this.temp = data['PO_Receptions_Available'];
        this.step = 1;
        this.getTotal();
        this.reorderDataExportExcel(this.listReceptions);

        this.aplicaWorkFlow = data['tipoOrden'] == 3 ? true : false;
        this.tipoOrden = data['tipoOrden'];

      } else {

        if (data['Response'].length > 0) {
          this.toastr.info(data['Response'][0].Mensaje, 'Ordenes Cerradas ');
          //this.toastr.info('No existen recepciones disponibles', 'Ordenes');
        }
      }
    }, (err) => {
      console.log(err);
      this.step = 0;
      this.listReceptions = null;
      this.temp = null;
      this.loadBtn = false;
      let msgRequired = err['error'][0].Response.Mensaje;
      let title = "Ordenes"
      if(this.translate.currentLang == "en"){
        title = "Purcharse order"
        msgRequired = "Purchase Order is invalid Failed to get SAP Orders: Error mapping PO_ITEM_HISTORY: Object reference not set for an instance of an object.";
      }else if(this.translate.currentLang == "es"){
          title = "Ordenes"
          msgRequired = err['error'][0].Response.Mensaje;
      }
      this.toastr.error(msgRequired, title);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });


  }
  selectAll(){
    for(let g = 0; g < this.listReceptions.length; g++){
      this.listReceptions[g].select = this.checkedAll;
      this.sumTot();
    }
  }

  subtotalItem( pos,index) {
    const idx = this.listReceptions.findIndex(x => x.Posicion_OrdenCompra === pos);
    this.listReceptions[idx].Importe_Local = this.listReceptions[idx].Cantidad * this.listReceptions[idx].PrecioUnitario;
    this.listReceptions[idx].CantidadItem = this.listReceptions[idx].Cantidad;
    this.sumTot();
  }

  uploadFiles(type){

    console.log("showExtranjero  %o", this.showExtranjero );
    if( this.showExtranjero ){
      type = 'foreign';
    }
    console.log("type %o", type );

    this.arra = [];
    for(let g = 0; g < this.listReceptions.length; g++){
      if(this.listReceptions[g].select){
        const paramspush = {
          PrecioPorUnidad: this.listReceptions[g].PrecioPorUnidad,
          AnhoRecepcion: this.listReceptions[g].YearDocumento,
          Planta: this.listReceptions[g].Planta,
          Autorizador: this.listReceptions[g].UsuarioAprobador,
          UnidadDeMedida: this.listReceptions[g].Unidad_Medida,
          IdUsuarioSeleccion: 13, //TODO: Falta asignar el id de usuario logueado
          OrdenCompra: this.listReceptions[g].Orden_Compra,
          NumRecepcion: this.listReceptions[g].Numero_Documento,
          Posicion: this.listReceptions[g].Posicion_OrdenCompra,
          Cantidad: this.listReceptions[g].CantidadItem,
          PrecioUnitario: this.listReceptions[g].PrecioUnitario,
          IndicadorDeImpuesto: this.listReceptions[g].Indicador_IVA,
          Moneda: this.listReceptions[g].Moneda,
          Almacen: this.listReceptions[g].Almacen,
          NumSociedad: this.listReceptions[g].Sociedad,
          Posicion_DocumentoRef: this.listReceptions[g].Posicion_DocumentoRef,
          CentroDeCosto: this.listReceptions[g].CentroDeCosto,
          OrdenInterna: this.listReceptions[g].OrdenInterna,
          AplicaML81N: this.listReceptions[g].AplicaML81N,
          SheetNo: this.listReceptions[g].SheetNo,
          IdTipoOrden: this.listReceptions[g].IdTipoOrden,
          Referencia: this.listReceptions[g].Referencia,
          UnidadDeMedidaPrecio: this.listReceptions[g].Unidad_MedidaPrecio,
          ImporteLinea : this.listReceptions[g].Importe_Local
        };

        this.arra.push(paramspush);
      }
    }
    if(this.arra.length < 1){
      let msgRequired = "Favor de seleccionar por lo menos una recepción";
        let title = "Cargar factura";
        if(this.translate.currentLang == "en"){
          title = "Upload invoice";
          msgRequired = "Please select at least one reception";
        }else if(this.translate.currentLang == "es"){
          title = "Cargar factura";
          msgRequired = "Favor de seleccionar por lo menos una recepción";
        }
      this.toastr.error(msgRequired, title);
      return;
    }
    const params = {
      xmlBase64: null,
      pdfBase64: null,
      numeroProveedor: this.data.provider,
      numeroSociedad: this.data.society,
      claveEmpresa: 'SMP',
      tipoOrden: this.tipoOrden,
      datosOrdenCompra: { listaRecepcionesDisponibles: this.arra },
      IdUsuarioSeleccion: this.userId
    };

    const dialogRef = this.dialog.open(ModalUploadComponent, {
      minWidth: '70%',
      position: {
        top: '6%'
      },
      data: { type: type, data: params, totalSelect: this.totalSelect }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.data = {};
        this.step = 0;
        this.listReceptions = null;
        this.arrOc = [];
        this.temp = null;
        this.checkedAll = false;
        this.arrRef = [];
      }
    });
  }

  sumTot(){
    let tot = 0;
    for(let g = 0; g < this.listReceptions.length; g++){
      if(this.listReceptions[g].select){
        tot += this.listReceptions[g].Importe_Local;
      }
    }
    this.totalSelect = tot;
  }

  getTotal(){
    setTimeout(() => {
      let tot = 0;
      for(let g = 0; g < this.listReceptions.length; g++){
        tot += this.listReceptions[g].Importe_Local;
      }
      this.total = tot;
    }, 500);
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  pasteRef(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if (string) {
          string.forEach(val => {
            if (val.trim()) {
              this.arrRef.push(val.trim());
            }
          });
        } else {
          if (value.trim()) {
            this.arrRef.push(value.trim());
          }
        }
      })
  }


  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('carga_ordenes_cerradas'));
  }

  listExcel =  [];
  reorderDataExportExcel(lista){
    console.log(lista)
    this.listExcel =  [];

    for(let i = 0; i < lista.length; i++){


      let params = {
          "Pos OC": lista[i].Orden_Compra,
          "Doc. Recepción": lista[i].Numero_Documento,
          "Posición": lista[i].Posicion_OrdenCompra,
          "Referencia": lista[i].Referencia,
          "Fecha": lista[i].Fecha_Contable,
          "Cantidad": lista[i].Cantidad,
          "Precio": lista[i].PrecioUnitario,
          "Importe": lista[i].Importe_Local,
          "Descripción": lista[i].Descripcion
      }

      console.log(params)
      this.listExcel.push(params);
    }
    console.log(this.listExcel);
  }
}
